import { RootState } from '@reducers';

export const selectFeatureHealthPlan = (state: RootState) => state.featureReducer.healthPlanReducer;
